module.exports = __webpack_public_path__ + "media/images/registration/fed_gov_employee_user-1dc564f05fcb5203bd9190a0466b8db1.png";